import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "../styles/Partners.css";

function PartnersList() {
  const { t, i18n } = useTranslation();
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}/partners/`, {
          headers: {
            'Accept-Language': i18n.language || 'fr'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setPartners(data);
        }
      } catch (error) {
        console.error("Error fetching partners:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, [i18n.language]);

  return (
    <section className="partners-list-section">
      <div className="section-header">
        <span className="section-badge">{t('partners.badge')}</span>
        <h2>{t('partners.title1')} <span className="keyword">{t('partners.titleKeyword')}</span></h2>
      </div>

      <div className="partners-grid">
        {loading ? (
          <p>{t('partners.loading')}</p>
        ) : partners.length > 0 ? (
          partners.map(partner => (
            <div key={partner.id} className="partner-card">
              <div className="partner-logo-container">
                {partner.logo ? (
                  <img src={partner.logo} alt={partner.nom} className="partner-logo-img" />
                ) : (
                  <div className="partner-logo-placeholder">
                    {partner.nom.charAt(0)}
                  </div>
                )}
              </div>
              <h3>{partner.nom}</h3>
            </div>
          ))
        ) : (
          <p>{t('partners.empty')}</p>
        )}
      </div>
    </section>
  );
}

export default PartnersList;
